import socket from '@/plugins/socket'
import ScoreTypeUnit from '@/store/model/sport/sport/ScoreTypeUnit'

export default {
  namespaced: true,
  state: {
    list: []
  },
  mutations: {
    set: (state, datas) => {
      state.list.splice(0)
      datas.forEach(item => { state.list.push(new ScoreTypeUnit(item)) })
    }
  },
  actions: {
    load (state) { socket.get('SportSportScoreunit', 'Sport/ScoreTypeUnit/set') }
  },
  getters: {
    list: (state) => state.list,
    get: (state) => (id) => state.list.find(item => item.id === id)
  }
}
